function instanceOfNumberRange(object) {
  return Array.isArray(object) && object.length === 2 && object.every((n) => typeof n === "number" && !Number.isNaN(n));
}
export {
  instanceOfNumberRange
};
